import { injectable } from 'inversify';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import differenceWith from 'lodash/differenceWith';

import { Widget } from '../../../types';

@injectable()
export class DashboardWidgetsService {
  /** Возвращает id изменённых виджетов или undefined, если изменений нет */
  checkWidgetChanges(
    initialData: Widget[],
    newData: Widget[],
    fields: string[],
  ): string[] | undefined {
    const getCompareData = (data: Widget[]) =>
      data?.map((item) => pick(item, ['id', ...fields]));

    const initialCompare = getCompareData(initialData);
    const newCompare = getCompareData(newData);

    const changedWidgets = differenceWith(newCompare, initialCompare, isEqual);

    return !!changedWidgets.length
      ? changedWidgets?.map((widget) => widget.id || '')
      : undefined;
  }
}
